import { styled, IconButton } from "@mui/material";
const Wrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  "&.MuiIconButton-root": {
    "&:hover": {
      backgroundColor: theme.palette.primary["75"]
    }
  }
}));
export {
  StyledIconButton,
  Wrapper
};
